import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

import { useToasts } from "@hooks/useToasts";

const Toasts = (): React.JSX.Element => {
    const { toasts, removeToast } = useToasts();

    const getBgVariant = (type?: string) => {
        switch (type) {
            case "error":
                return "danger";
            case "warning":
                return "warning";
            case "info":
                return "info";
            default:
                return "success";
        }
    };
    return (
        <ToastContainer position="bottom-end" className="p-3">
            {toasts.map(toast => (
                <Toast
                    key={toast.id}
                    show={true}
                    onClose={() => removeToast(toast.id)}
                    autohide
                    delay={toast.delay}
                    bg={getBgVariant(toast.type)}
                >
                    <Toast.Body className="text-white">
                        {toast.message}
                    </Toast.Body>
                </Toast>
            ))}
        </ToastContainer>
    );
};

export default Toasts;
